// extracted by mini-css-extract-plugin
export default {"teacherContainer":"CategoryLessons_teacherContainer__F+40U","lessonsContainer":"CategoryLessons_lessonsContainer__s+2j0"};